var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{staticClass:"errormodal",attrs:{"id":"error-modal","title":"錯誤訊息","hide-footer":""}},[_c('p',{staticClass:"errormodal__text"},[_vm._v(_vm._s(_vm.errorMessage))])])}
var staticRenderFns = []

export { render, staticRenderFns }